import { render, staticRenderFns } from "./NodeNote.vue?vue&type=template&id=08a70328&scoped=true"
import script from "./NodeNote.vue?vue&type=script&lang=js"
export * from "./NodeNote.vue?vue&type=script&lang=js"
import style0 from "./NodeNote.vue?vue&type=style&index=0&id=08a70328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a70328",
  null
  
)

export default component.exports